module.exports = __webpack_public_path__ + "img/reduce.ef2df615.svg";